import { IconPropsType } from '..';

export const LetterIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.875 3H2.125C1.97724 2.99992 1.83091 3.02896 1.69438 3.08547C1.55785 3.14197 1.4338 3.22484 1.32932 3.32932C1.22484 3.4338 1.14197 3.55785 1.08547 3.69438C1.02896 3.83091 0.999916 3.97724 1 4.125L1 15.875C0.999916 16.0228 1.02896 16.1691 1.08547 16.3056C1.14197 16.4421 1.22484 16.5662 1.32932 16.6707C1.4338 16.7752 1.55785 16.858 1.69438 16.9145C1.83091 16.971 1.97724 17.0001 2.125 17H17.875C18.0228 17.0001 18.1691 16.971 18.3056 16.9145C18.4421 16.858 18.5662 16.7752 18.6707 16.6707C18.7752 16.5662 18.858 16.4421 18.9145 16.3056C18.971 16.1691 19.0001 16.0228 19 15.875V4.125C19.0001 3.97724 18.971 3.83091 18.9145 3.69438C18.858 3.55785 18.7752 3.4338 18.6707 3.32932C18.5662 3.22484 18.4421 3.14197 18.3056 3.08547C18.1691 3.02896 18.0228 2.99992 17.875 3ZM17 5V5.5L10 9.57971L3 5.5V5H17ZM3 15V8L9.44189 11.8517C9.61184 11.9489 9.80422 12 10 12C10.1958 12 10.3882 11.9489 10.5581 11.8517L17 8V15H3Z"
      fill="currentColor"
    />
  </svg>
);
